import { computed, watch, type Ref } from 'vue'
import { usePointerSwipe } from '@vueuse/core'
import { useSamudkoyStore } from '@/modules/simakatra/stores/samudkoy'

export function useFlipbookSamudkoy(swipeRef: Ref<HTMLElement | undefined>) {
  const samudkoyStore = useSamudkoyStore()

  const page = computed(() => samudkoyStore.page)
  const isActivated = computed(()=> samudkoyStore.isActivated )

  const { isSwiping, direction } = usePointerSwipe(swipeRef)

  watch(isSwiping, (isSwiping) => {
    if (isSwiping) {
      const dir = direction.value
      if (dir == 'up' || dir == 'left') samudkoyStore.flipUp()
      if (dir == 'down' || dir == 'right') samudkoyStore.flipDown()
    }
  })

  return {
    page,
    isActivated
  }
}
